import ListingMarker from "./ListingMarker";
import ListingPopup from "./ListingPopup";
import PinMarker from "./PinMarker";
import PinPopup from "./PinPopup";
import ClusterMarker from "./ClusterMarker";
import ClusterPopup from "./ClusterPopup";
import ClusterListing from "./ClusterListing";
import SubjectPropertyMarker from "./SubjectPropertyMarker";
var Markers = {
    ListingMarker: ListingMarker,
    ListingPopup: ListingPopup,
    PinMarker: PinMarker,
    PinPopup: PinPopup,
    ClusterMarker: ClusterMarker,
    ClusterPopup: ClusterPopup,
    ClusterListing: ClusterListing,
    SubjectPropertyMarker: SubjectPropertyMarker
};
export default Markers;
